import React, { Component } from "react";
import "./stylesheets/header.css";
import constant from "../../configs/constant";
import {
  getJobs,
  getSiteId,
  getTypeofWork,
  getProfile,
  getNotification,
  getNotificationCount,
  getExpirePassword,
} from "../../modules/serverCall";
import Auth from "../../modules/Auth";
import { Navbar, Nav, Container, NavItem } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import { isMobile } from "react-device-detect";
import { Modal } from "react-bootstrap";
import { CgNotes } from "react-icons/cg";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      linkDisable: false,
      scope: "Services",
      submitbutton: true,
      showSplash: false,
      tantedList: [],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const accesstokendataMain = localStorage.getItem("user_tenant");
    const readDataMain = JSON.parse(accesstokendataMain);
    const accessselectedtentant = localStorage.getItem("selected_tenant");
    const readDataSelected = JSON.parse(accessselectedtentant);
    var tantedList = readDataMain;
    this.setState({
      tantedList: tantedList,
    });
    if (readDataSelected === null) {
      this.setState({
        showClass: true,
      });
    }
    var month = new Date().getMonth();
    var currentCount = parseInt(month);
    var monthData = currentCount + 1;
    var year = new Date().getFullYear();
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const cusId = readData.userdata.user_id;
    var sendData = {
      month: monthData,
      year: year,
      techId: cusId,
    };
    getJobs(sendData);

    console.log(readDataSelected);

    if (readDataSelected.Tenant !== "Thisco") {
      const fetchResetPassword = async () => {
        try {
          const responsenotificationCount = await getExpirePassword();

          if (responsenotificationCount) {
            this.setState({
              linkDisable: true,
            });
          } else {
            this.setState({
              linkDisable: false,
            });
          }
        } catch (error) {
          console.log("Error fetching password expiration:", error);
        }
      };

      fetchResetPassword();
    }

    const fetchnotificationCount = async () => {
      const responsenotificationCount = await getNotificationCount(sendData);
      const datarespnotificationCount = await responsenotificationCount;
      this.setState({
        notificationCount: datarespnotificationCount.UnreadCount,
      });
    };
    fetchnotificationCount();
    const splashShowed = localStorage.getItem("splashShowed");
    if (!splashShowed || splashShowed === "false") {
      this.checkSplashScreen();
    }
  }

  checkSplashScreen = () => {
    const lastSplashDate = localStorage.getItem("last_splash_date");
    const today = new Date();
    if (!lastSplashDate) {
      localStorage.setItem("last_splash_date", today);
    }
    const lastSplashDateSaved = new Date(
      localStorage.getItem("last_splash_date")
    );

    if (today.getDate() - lastSplashDateSaved.getDate() > 2) {
      this.setState({ showSplash: false });
    } else {
      // this.setState({ showSplash: true });
    }
  };
  handleChange = (event) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to logout?",
      icon: "warning",
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        Auth.logout();
      }
    });
  };

  handleClose = (event) => {
    this.setState({
      showClass: false,
    });
  };

  handleCloseSplash = (event) => {
    this.setState({
      showSplash: false,
    });
    localStorage.setItem("splashShowed", "true");
  };

  handleShowData = (event) => {
    const accesstokendata = localStorage.getItem("user_tenant");
    const readData = JSON.parse(accesstokendata);
    var tantedList = readData;
    this.setState({
      tantedList: tantedList,
      showClass: true,
    });
  };

  handleTenant = (event) => {
    const accesstokendata = localStorage.getItem("access_token");
    const readData = JSON.parse(accesstokendata);
    const accesstokendataAuth = localStorage.getItem("auth");
    const readDataAuth = JSON.parse(accesstokendataAuth);
    const cusId = readData.userdata.user_id;
    const username = readData.userdata.sub;

    var selected_tenant = {
      ApplicationTenantID: event.ApplicationTenantID,
      Tenant: event.Tenant,
    };
    localStorage.setItem("selected_tenant", JSON.stringify(selected_tenant));

    var sendData = {
      techId: cusId,
    };
    getSiteId(readDataAuth, cusId);
    getProfile(cusId);
    getNotification(sendData);
    getTypeofWork(readDataAuth, username);

    this.setState({
      showClass: false,
    });
    setInterval(function () {
      window.location.reload();
    }, 1000);
  };

  render() {
    const logocompany = require("../../assets/images/Thejo Splice logofive.png");
    const spliceLogo = require("../../assets/images/SpliceLogo.png");
    var tantedList = this.state.tantedList;

    const selectedTenant = localStorage.getItem("selected_tenant");
    const selectedTenantData = JSON.parse(selectedTenant);
    return (
      <header>
        <Navbar bg="light" expand="lg">
          <Container>
            <Navbar.Brand href="#home">
              <NavLink
                className="nav-link nav-link-data text-end"
                to={`${
                  this.state.linkDisable ? "/change-password" : "/create-job"
                }`}
              >
                <img src={logocompany} alt="logo" className="logo-header" />
              </NavLink>
            </Navbar.Brand>
            <span className="header_name">
              <b>
                <img src={spliceLogo} alt="logo" className="icon-header" />
              </b>
              <span className="verClass">{constant.appVersions}</span>
            </span>
            {isMobile === true ? (
              <span class="badgeout">{this.state.notificationCount}</span>
            ) : (
              ""
            )}
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <NavLink
                  className="nav-link nav-link-data text-end"
                  to={`${
                    this.state.linkDisable ? "/change-password" : "/create-job"
                  }`}
                >
                  New Job{" "}
                </NavLink>
                <NavLink
                  className="nav-link nav-link-data text-end"
                  to={`${
                    this.state.linkDisable ? "/change-password" : "/my-work"
                  }`}
                >
                  My Works
                </NavLink>

                <NavLink
                  className="nav-link nav-link-data text-end"
                  style={{
                    position: "relative",
                  }}
                  to={`${
                    this.state.linkDisable
                      ? "/change-password"
                      : "/notification-front"
                  }`}
                >
                  Notification
                  <span class="badge">{this.state.notificationCount}</span>
                </NavLink>

                {/* <NavLink
                  className="nav-link nav-link-data text-end"
                  to="/change-password"
                >
                  Change Password
                </NavLink> */}

                {selectedTenantData.Tenant === "Thisco" ? null : (
                  <NavLink
                    className="nav-link nav-link-data text-end"
                    to="/change-password"
                  >
                    Change Password
                  </NavLink>
                )}

                <NavLink
                  className="nav-link nav-link-data text-end"
                  to={`${
                    this.state.linkDisable
                      ? "/change-password"
                      : "/user-profile"
                  }`}
                >
                  Profile
                </NavLink>
                {tantedList.length > 1 ? (
                  <NavItem
                    className="nav-link nav-link-data text-end cursorClass"
                    onClick={this.handleShowData}
                  >
                    Change Tenant
                  </NavItem>
                ) : (
                  ""
                )}
                <NavItem
                  className="nav-link nav-link-data text-end cursorClass"
                  onClick={this.handleChange}
                >
                  Logout
                </NavItem>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Modal
          show={this.state.showClass}
          backdrop="static"
          onHide={this.state.handleClose}
        >
          <Modal.Header>
            <Modal.Title>Select</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modelBody">
            {tantedList !== ""
              ? tantedList.map((item, indexdata) => {
                  return (
                    <p
                      className="tenantClass"
                      onClick={(event) => this.handleTenant(item)}
                    >
                      {item.Tenant}
                    </p>
                  );
                })
              : ""}
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.showSplash}
          backdrop="static"
          className=" d-flex align-items-center justify-content-center "
          onHide={() => this.setState({ showSplash: false })}
        >
          <Modal.Body className="modelBody modal-bg-img">
            <span onClick={this.handleCloseSplash} className="cross-btn">
              x
            </span>
            <div className="d-flex flex-col">
              <div>
                <img
                  src="https://d2o6woj9n5zgsq.cloudfront.net/images/blog/photos/EPAs+New+Tier+4+Final+Emission+Standards+Trigger+New+Construction+Technologies.jpg"
                  className="bgimage-modal"
                />
              </div>
              <div className="mt-2  p-4">
                <div>
                  {" "}
                  <img
                    src={logocompany}
                    alt="logo"
                    className="logo-header-back logo-size"
                  />
                </div>
                <h2 className="update-heading mt-2"> New Feature Update !! </h2>
                <div className="update-para mt-2">Latest version : v2</div>
                {/* <div className="update-para">is now online...</div> */}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </header>
    );
  }
}
